export const messages = {
  title: {
    id: 'admin/promotions.form.regular.scope.title',
  },
  applyTo: {
    allItems: {
      id: 'admin/promotions.form.regular.editor.scope.apply-to.all-items',
    },
    filteredItems: {
      id: 'admin/promotions.form.regular.editor.scope.apply-to.filtered-items',
    },
  },
  operator: {
    equalsTo: {
      id: 'admin/promotions.form.utils.equals-to',
    },
    differentFrom: {
      id: 'admin/promotions.form.utils.different-from',
    },
  },
  alert: {
    id: 'admin/promotions.form.regular.editor.scope.alert',
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.select-an-option',
    },
  },
  brands: { id: 'admin/promotions.form.scope.brands.select.label' },
  categories: {
    id: 'admin/promotions.form.scope.categories.select.label',
  },
  collections: { id: 'admin/promotions.form.selector.collections.label' },
  products: {
    id: 'admin/promotions.form.scope.products.select.label',
  },
  skus: {
    id: 'admin/promotions.form.scope.skus.select.label',
  },
  remove: {
    id: 'admin/promotions.utils.remove',
  },
}
